import { render, staticRenderFns } from "./ModalReqOTP.vue?vue&type=template&id=7295b001&scoped=true&"
import script from "./ModalReqOTP.vue?vue&type=script&lang=js&"
export * from "./ModalReqOTP.vue?vue&type=script&lang=js&"
import style0 from "./ModalReqOTP.vue?vue&type=style&index=0&id=7295b001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7295b001",
  null
  
)

export default component.exports